import { render } from "./license-warning-banner.vue?vue&type=template&id=6225062a&ts=true"
import script from "./license-warning-banner.vue?vue&type=script&lang=ts"
export * from "./license-warning-banner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__